import Swiper from 'swiper';
import { Autoplay, Pagination, EffectCreative, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import 'swiper/css/effect-creative';
import 'swiper/css/mousewheel';
import gsap from 'gsap';

// modules/_map.tsを読み込んで初期化
import { initMap } from './modules/_map';
initMap();

// common variables
const mql = window.matchMedia('(min-width: 768px)');
const mqlLg = window.matchMedia('(min-width: 1024px');
const kv = document.getElementById('kv');

// reload on resize
mql.onchange = () => {
  location.reload();
}

mqlLg.onchange = () => {
  location.reload();
};

// kv animation
if (kv) {
  window.addEventListener('DOMContentLoaded', () => {
    kv.classList.add('is-animated');
  });
}

// swiper
const topPickupSwiperOption = {
  modules: [EffectCreative, Autoplay, Pagination],
  init: false,
  loop: true,
  effect: 'creative',
  speed: 1000,
  creativeEffect: {
    prev: {
      translate: [0, '-105%', 0],
    },
    next: {
      translate: [0, '105%', 0],
      scale: 1.1,
    },
  },

  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
};

const topPickupSwiper = document.getElementById('top-pickup-slider');

if (topPickupSwiper) {
  const pickupSliderSwitchButtons = document.getElementById('pickup-slider-switch-buttons');
  const topPickupPagination = document.querySelector('.js-top-pickup-pagination');
  const pickupSliderStopButton = document.getElementById('pickup-slider-stop-button');
  const pickupSliderPlayButton = document.getElementById('pickup-slider-play-button');

  const swiper = new Swiper(topPickupSwiper, {
    ...topPickupSwiperOption,

    pagination: {
      el: '.js-top-pickup-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `<span class="${className}" data-num="${index}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><circle cx="5" cy="5" r="4.5" fill="none" stroke="#222"/></svg></span>`;
      },
    },
  });

  swiper.on('init', function() {
    if (pickupSliderSwitchButtons) {
      pickupSliderSwitchButtons.classList.add('is-init');

      const topPickupPaginationHeight = topPickupPagination?.clientHeight;

      if (topPickupPaginationHeight && pickupSliderSwitchButtons) {
        if (mql.matches) {
          pickupSliderSwitchButtons.style.top = `${topPickupPaginationHeight + 10}px`;
        } else {
          pickupSliderSwitchButtons.style.top = `${topPickupPaginationHeight + 5}px`;
        }
      }
    }
  });

  swiper.init();

  if (pickupSliderStopButton) {
    pickupSliderStopButton.addEventListener('click', () => {
      swiper.autoplay.stop();
      pickupSliderStopButton.classList.add('is-hidden');

      if (pickupSliderPlayButton) {
        pickupSliderPlayButton.classList.add('is-show');
      }
    });
  }

  if (pickupSliderPlayButton) {
    pickupSliderPlayButton.addEventListener('click', () => {
      swiper.autoplay.start();

      if (pickupSliderStopButton) {
        pickupSliderStopButton.classList.remove('is-hidden');
      }

      pickupSliderPlayButton.classList.remove('is-show');
    });
  }
}

const topPickupSwiperMobile = document.getElementById(
  'top-pickup-slider-mobile'
);

if (topPickupSwiperMobile) {
  const pickupSliderSwitchButtonsMobile = document.getElementById('pickup-slider-switch-buttons-mobile');
  const topPickupPaginationMobile = document.querySelector('.js-top-pickup-pagination-mobile');
  const pickupSliderStopButtonMobile = document.getElementById('pickup-slider-stop-button-mobile');
  const pickupSliderPlayButtonMobile = document.getElementById('pickup-slider-play-button-mobile');

  const swiper = new Swiper(topPickupSwiperMobile, {
    ...topPickupSwiperOption,

    pagination: {
      el: '.js-top-pickup-pagination-mobile',
      clickable: true,
      renderBullet: function (index, className) {
        return `<span class="${className}" data-num="${index}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10"><circle cx="5" cy="5" r="4.5" fill="none" stroke="#222"/></svg></span>`;
      },
    },
  });


  swiper.on('init', function() {
    if (pickupSliderSwitchButtonsMobile) {
      pickupSliderSwitchButtonsMobile.classList.add('is-init');

      const topPickupPaginationHeight = topPickupPaginationMobile?.clientHeight;

      if (topPickupPaginationHeight && pickupSliderSwitchButtonsMobile) {
        pickupSliderSwitchButtonsMobile.style.top = `${topPickupPaginationHeight + 5}px`;
      }
    }
  });

  swiper.init();

  if (pickupSliderStopButtonMobile) {
    pickupSliderStopButtonMobile.addEventListener('click', () => {
      swiper.autoplay.stop();
      pickupSliderStopButtonMobile.classList.add('is-hidden');

      if (pickupSliderPlayButtonMobile) {
        pickupSliderPlayButtonMobile.classList.add('is-show');
      }
    });
  }

  if (pickupSliderPlayButtonMobile) {
    pickupSliderPlayButtonMobile.addEventListener('click', () => {
      swiper.autoplay.start();

      if (pickupSliderStopButtonMobile) {
        pickupSliderStopButtonMobile.classList.remove('is-hidden');
      }

      pickupSliderPlayButtonMobile.classList.remove('is-show');
    });
  }
}

// nav
const nav = document.getElementById('nav');
const navButton = document.getElementById('nav-button');

if (navButton && nav) {
  navButton.addEventListener('click', () => {
    navButton.classList.toggle('is-opened');
    nav.classList.toggle('is-opened');
  });
}

const mapPopup = document.getElementById('map-popup');
const mapButton = document.getElementById('map-button');

if (mapButton && mapPopup) {
  mapButton.addEventListener('click', () => {
    mapButton.classList.toggle('is-opened');
    mapPopup.classList.toggle('is-opened');
  });
}

// according
const details = document.querySelectorAll('.js-details');
const IS_OPENED_CLASS = 'is-opened';

details.forEach((element) => {
  const summary = element.querySelector('.js-summary');
  const content = element.querySelector('.js-content');

  if (summary) {
    summary.addEventListener('click', (event) => {
      event.preventDefault();

      if (element.classList.contains(IS_OPENED_CLASS)) {
        element.classList.toggle(IS_OPENED_CLASS);

        closingAnim(content, element).restart();
      } else {
        element.classList.toggle(IS_OPENED_CLASS);

        element.setAttribute('open', 'true');

        openingAnim(content).restart();
      }
    });
  }
});

const closingAnim = (content: gsap.TweenTarget, element: Element) =>
  gsap.to(content, {
    height: 0,
    duration: 0.4,
    ease: 'power3.out',
    overwrite: true,
    onComplete: () => {
      element.removeAttribute('open');
    },
  });

const openingAnim = (content: gsap.TweenTarget) =>
  gsap.fromTo(
    content,
    {
      height: 0,
    },
    {
      height: 'auto',
      duration: 0.4,
      ease: 'power3.out',
      overwrite: true,
    }
  );

// scroll animation trigger
const scrollAnimationTrigger = () => {
  const callback: IntersectionObserverCallback = (entries) => {
    entries.forEach((entry: IntersectionObserverEntry) => {
      if (entry.isIntersecting) {
        const target = entry.target;
        target.classList.add('is-animated');
      }
    });
  };

  const options = {
    rootMargin: '0px 0px -25%',
  };

  const observer = new IntersectionObserver(callback, options);

  const targets = document.querySelectorAll('[data-animation-trigger]');
  targets.forEach((target) => {
    observer.observe(target);
  });
};
scrollAnimationTrigger();

// recommend swiepr
const recommendSlider = document.getElementById('recommend-slider');

if (recommendSlider) {
  const swiper = new Swiper(recommendSlider, {
    modules: [Mousewheel],
    init: false,
    loop: false,
    slidesPerView: 2.2,
    spaceBetween: 15,
    mousewheel: {
      enabled: true,
      forceToAxis: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 3.3,
        spaceBetween: 30,
      },
    },
  });

  swiper.init();
}

// single neighborhood
const singleNeighborhood = document.getElementById('single-neighborhood');
if (singleNeighborhood) {
  const changeProfileContentHeight = () => {
    const sigleDescription = document.querySelector('.js-single-description');
    const neighborhoodHeader = document.querySelector('.js-neighborhood-header');
    const profileTitle = document.querySelector('.js-profile-title');
    const profileContent = document.querySelector('.js-profile-content');

    if (sigleDescription && neighborhoodHeader && profileTitle && profileContent) {
      const singleDescriptionHeight = sigleDescription.clientHeight;
      const neighborhoodHeaderHeight = neighborhoodHeader.clientHeight;
      const profileTitleHeight = profileTitle.clientHeight;

      const content = profileContent as HTMLElement;
      content.style.height = `${singleDescriptionHeight - neighborhoodHeaderHeight- profileTitleHeight}px`;
    }
  }

  if (mql.matches) {
    changeProfileContentHeight();
  }

  window.addEventListener('resize', () => {
    if (mql.matches) {
      changeProfileContentHeight();
    }
  });
}

// fixed viewport 320px
const viewport = document.querySelector('meta[name="viewport"]');
function switchViewport() {
  const value =
    window.outerWidth > 320
      ? 'width=device-width,initial-scale=1'
      : 'width=320';
  if (viewport && viewport.getAttribute('content') !== value) {
    viewport.setAttribute('content', value);
  }
}
addEventListener('resize', switchViewport, false);
switchViewport();

